import {createDraftActions, createFetchListActions} from 'common/actions/utils';
import AgencySettings, {paymentProviders} from 'common/types/AgencySettings';
import OdAdminApi from 'common/api/OdAdminApi';
import AgencyApi from 'common/api/AgencyApi';

const agencyApi = new AgencyApi();

export const {
  requestAgencySettings,
  receiveAgencySettings,
  fetchAgencySettings,
  fetchAgencySettingsIfNeeded,
} = createFetchListActions({
  name: 'agency setting',
  DataType: AgencySettings,
  keys: ['agency'],
  api: new OdAdminApi(),
});

export const {
  newAgencySettingDraft,
  setAgencySettingDraft,
  editAgencySettingDraft,
  saveAgencySettingDraft,
  clearAgencySettingDraft,
  receiveAgencySettingDraftErrors,
  sendAgencySettingDraft,
} = createDraftActions({
  name: 'agency setting',
  DataType: AgencySettings,
  api: new OdAdminApi(),
});

export const CLEAR_PAYMENT_CONNECT = 'CLEAR_PAYMENT_CONNECT';

export function clearStripe() {
  return {
    type: CLEAR_PAYMENT_CONNECT,
  };
}

export const SEND_PAYMENT_CONNECT = 'SEND_PAYMENT_CONNECT';

export function sendPaymentConnect() {
  return {
    type: SEND_PAYMENT_CONNECT,
  };
}

export const RECEIVE_PAYMENT_CONNECT_ERROR = 'RECEIVE_PAYMENT_CONNECT_ERROR';

export function receivePaymentConnectError() {
  return {
    type: RECEIVE_PAYMENT_CONNECT_ERROR,
  };
}

export const RECEIVE_PAYMENT_CONNECT_SUCCESS = 'RECEIVE_PAYMENT_CONNECT_SUCCESS';

export function receivePaymentConnectSuccess() {
  return {
    type: RECEIVE_PAYMENT_CONNECT_SUCCESS,
  };
}

export function requestPaymentConnect(agencyId, provider, params) {
  return async (dispatch) => {
    dispatch(sendPaymentConnect());
    let response;
    if (provider === paymentProviders.STRIPE) {
      response = await agencyApi.connectStripe(agencyId, params);
    } else {
      response = await agencyApi.connectTokenTransit(agencyId, params);
    }
    switch (response.status) {
      case 200:
        dispatch(receivePaymentConnectSuccess());
        return response;
      default:
        dispatch(receivePaymentConnectError());
        return response;
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/actions/agencySettings.js